/* eslint-disable @typescript-eslint/explicit-function-return-type */
import Config from '../config';

import { configureStore as configureDevelopmentStore } from './store.development';
import { configureStore as configureProductionStore } from './store.production';

class Store {
  store: any;

  constructor() {
    this.store =
      Config.NODE_ENV === 'development' ? configureDevelopmentStore() : configureProductionStore();
  }

  getStore() {
    return this.store.store;
  }

  getPersistor() {
    return this.store.persistor;
  }
}

export default new Store();
